import { CommonModule } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ClaimsJsonValidatorService } from 'app/shared/components/debug-tools/claims-json-validator/claims-json-validator.service';
import { DebugToolsConfigService } from 'app/shared/components/debug-tools/debug-tools-config.service';
import { UniversalSearchDialogService } from 'app/shared/components/universal-search/universal-search-dialog.service';

@Component({
    selector: 'upsc-debug-button',
    templateUrl: './debug-button.component.html',
    styleUrls: ['./debug-button.component.scss'],
    standalone: true,
    providers: [
        UniversalSearchDialogService,
        DebugToolsConfigService,
        ClaimsJsonValidatorService,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
    ],
})
export class DebugButtonComponent {
    @HostBinding('class') public hostClass = 'debug-button';

    private readonly universalSearchDialogService = inject(UniversalSearchDialogService);
    private readonly debugToolsConfigService = inject(DebugToolsConfigService);

    public openUniversalSearchDialog(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.universalSearchDialogService.open(this.debugToolsConfigService.DEBUG_TOOLS_CONFIG);
    }
}
